import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Watchlist = ({ userId, config }) => {
  const [watchlist, setWatchlist] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    fetchWatchlist();
  }, []);

  const fetchWatchlist = async () => {
    try {
      const response = await axios.get(`${config.PY_API_URL}/member/watchlist/${userId}`);
      setWatchlist(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching watchlist:', error);
      setLoading(false);
    }
  };

  const addToWatchlist = async (productId) => {
    try {
      await axios.post(`${config.PY_API_URL}/member/watchlist`, { user_id: userId, product_id: productId });
      fetchWatchlist();  // Refresh the watchlist
    } catch (error) {
      console.error('Error adding to watchlist:', error);
    }
  };

  const removeFromWatchlist = async (productId) => {
    try {
      await axios.post(`${config.PY_API_URL}/member/watchlist/delete`, { user_id: userId, product_id: productId });
      fetchWatchlist();  // Refresh the watchlist
    } catch (error) {
      console.error('Error removing from watchlist:', error);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <h2>Your Watchlist</h2>
      <ul>
        {watchlist.map((item) => (
          <li key={item.product_id}>
            Product ID: {item.product_id} {item.name}
            <button onClick={() => removeFromWatchlist(item.id)}>Remove</button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Watchlist;
